import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './configure-email.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';
let $ = require('jquery');

@Component({
  selector: 'configure-email',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./configure-email.scss')],
  template: require('./configure-email.html')
})

export class ConfigureEmail {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedEntity') selectedEntity;
  @Output('onRequestStatusChange') emitter = new EventEmitter();

  private subscribeHandler;
  private active: boolean = true;
  private emailList = '';

  private isDataLoading: boolean = true;
  private isDeleteAllButtonVisible: boolean = false;

  private isRequestPending: boolean = false;
  private emitData = {
    status: ''
  };

  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit(f: NgForm) {
    this.isRequestPending = true;
    this.emitData.status = 'pending';
    this.emitter.emit(this.emitData);
    switch(this.mode){
    case DataProtectionVariables.MODES['RESOURCE_POOL']:
      this.configureEmailResourcePool(f.value);
      break;
    case DataProtectionVariables.MODES['VM']:
      this.configureEmailVirtualMachine(f.value);
      break;
    default :
      this.configureEmailVirtualMachine(f.value);
    }
  }

  onCancelButtonClicked() {
    this.emitter.emit();
  }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (changes.isVisible && this.isVisible && this.selectedEntity && this.selectedEntity.entity_id !== '') {
      this.isDeleteAllButtonVisible = false;
      if (this.mode === DataProtectionVariables.MODES['RESOURCE_POOL']) {
        this.getEmailResourcePool(this.selectedEntity.vcenter_instanceId, this.selectedEntity.entity_id);
      } else {
        this.getEmailVirtualMachine(this.selectedEntity.vcenter_instanceId, this.selectedEntity.entity_id);
      }
    } else {
      this.reset();
      this.isDataLoading = true;
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if (this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  constructEmailObject(emailList) {
    let emails = (emailList && $.trim(emailList) != "") ? emailList.split(',') : [];
    let emailIdList = [];
    for (let email of emails) {
      emailIdList.push($.trim(email));
    }
    return {
      'emailIds': emailIdList
    };
  }

  configureEmailResourcePool(formValue) {
    if (formValue && this.selectedEntity && this.selectedEntity.entity_id !== ''
                  && this.selectedEntity.vcenter_instanceId !== '') {
      let emailObj = this.constructEmailObject((formValue.email)? formValue.email : '');
      this.subscribeHandler = this.service.configureEmailResourcePool(this.selectedEntity.vcenter_instanceId,this.selectedEntity.entity_id, emailObj)
        .subscribe(
          res => {
            this.handleSuccess();
          },
          error => {
            this.handleError(error)
          },
          () => {}
        );
    }
    else{}
  }

  configureEmailVirtualMachine(formValue) {
    if( formValue && this.selectedEntity && this.selectedEntity.entity_id !== ''
                  && this.selectedEntity.vcenter_instanceId !== '' ) {
      let emailObj = this.constructEmailObject((formValue.email)? formValue.email : '');
      this.subscribeHandler = this.service.configureEmailVirtualMachine(this.selectedEntity.vcenter_instanceId, this.selectedEntity.entity_id, emailObj)
        .subscribe(
          res => {
            this.handleSuccess();
          },
          error => this.handleError(error),
          () => {}
        );
    }
    else{}
  }

  getEmailResourcePool(vcId, rpId) {
    this.subscribeHandler = this.service.getEmailResourcePool(vcId, rpId)
      .subscribe(
        (eList: any) => {
          this.emailList = (eList && eList['emailIds'] && eList['emailIds'].constructor === Array)? eList['emailIds'].join(', ') : '';
          this.isDeleteAllButtonVisible = (this['emailList'] && this['emailList'] != '');
          this.isDataLoading = false;
        },
        error => {
          this.isDataLoading = false;
        },
        () => {}
      );
  }

  getEmailVirtualMachine(vcId, vmId) {
    this.subscribeHandler = this.service.getEmailVirtualMachine(vcId, vmId)
      .subscribe(
        (eList: any) => {
          this.emailList = (eList && eList['emailIds'] && eList['emailIds'].constructor === Array)? eList['emailIds'].join(', ') : '';
          this.isDeleteAllButtonVisible = (this['emailList'] && this['emailList'] != '');
          this.isDataLoading = false;
        },
        error => {
          this.isDataLoading = false;
        },
        () => {}
      );
  }

  reset() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
    this.emailList = null;
  }

  handleSuccess() {
    this.isRequestPending = false;
    this.emitData.status = 'success';
    this.emitter.emit(this.emitData);
  }

  handleError(error) {
    this.isRequestPending = false;
    this.emitData.status = 'error';
    this.emitter.emit(this.emitData);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/configure-email/configure-email.component.ts